import React from 'react'

function References() {
    return (
        <div className="container">
            <ul>
                <br />
                <div><a href="https://reactjs.org/docs/hooks-intro.html" target="_">Introducing Hooks</a></div>
                <br />
                <div><a href="https://youtu.be/f687hBjwFcM" target="_">YT Tutorial</a></div>
            </ul>
        </div>
    )
}

export default References
